import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatBytes',
})
export class FormatBytesPipe implements PipeTransform {
    transform = formatBytes;
}

export function formatBytes(bytes: number, decimals = 2) {
    if (bytes === 0) {
        return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const res = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));

    // Return '0 Bytes' if result is NaN
    return isNaN(res) ? '0 Bytes' : res + ' ' + sizes[i];
}
